import { Card, Collapse, Grid, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React from 'react'

import { Arrow } from './Arrow'
import { Basic } from './Basic'
import { Group } from './Group'

export const TooltipComponentsDemo: React.FC = () => {
    const [opened, { toggle }] = useDisclosure(true)
    return (
        <Card withBorder>
            <Title order={2} onClick={toggle}>
                文字提示
            </Title>
            <Collapse in={opened}>
                <Grid gutter={20}>
                    <Grid.Col span={6}>
                        <Basic />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Group />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Arrow />
                    </Grid.Col>
                </Grid>
            </Collapse>
        </Card>
    )
}
